import React, { useState, useEffect } from 'react';
import { Box, Radio, Stack, Checkbox, FormControlLabel } from '@mui/material';

const ANSWER_OPTIONS = {
  excellent_to_poor: ['Excellent', 'Good', 'Average', 'Fair', 'Poor'],
  highly_to_unlikely: [
    'Highly Likely',
    'Somewhat Likely',
    'Neutral',
    'Somewhat Unlikely',
    'Highly Unlikely',
  ],
  yes_no: ['Yes', 'No'],
  one_to_five: ['Five', 'Four', 'Three', 'Two', 'One'],
  thumbs_up_down: ['Thumbs Up', 'Thumbs Down'],
  smiley_frowney: ['Satisfied', 'Dissatisfied'],
};

export const MultipleChoiceQuestion = ({ question, answer, onAnswerChange, primaryColor }) => {
  const baseOptions = ANSWER_OPTIONS[question.q_type] || question.q_option;
  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  if (!baseOptions) return null;

  // const options = !question.required ? [...baseOptions, 'N/A'] : baseOptions;
  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    onAnswerChange(checked ? 'N/A' : '');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {baseOptions.map((option, index) => {
        const selected = answer === option;
        return (
          <Stack
            key={`${option}${index}`}
            direction="row"
            alignItems="center"
            value={isNA ? '' : option}
            onClick={() => !isNA && onAnswerChange(option)}
            sx={{
              border: `1px solid ${selected ? (primaryColor || '#2aa1d3') : '#ddd'}`,
              borderRadius: 2,
              padding: '4px 16px 4px 4px',
              cursor: isNA ? 'default' : 'pointer',
              background: '#fff',
              opacity: isNA ? 0.4 : 1,
              transition: 'border-color 0.2s, opacity 0.2s',
              '&:hover': { borderColor: isNA ? '#ddd' : (primaryColor || '#2aa1d3') },
            }}
          >
            <Radio
              checked={selected}
              readOnly
              size="small"
              sx={{
                color: '#ccc',
                '&.Mui-checked': { color: primaryColor || '#2aa1d3' },
              }}
            />
            <Box sx={{ fontSize: '15px', color: '#333' }}>{option}</Box>
          </Stack>
        );
      })}
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 0.5 }}
        />
      )}
    </Box>
  );
};